export default __webpack_public_path__ + "static/media/google.94879ccf.svg";